import React from "react";
import { AnalyticsGraphLoaderTemplate } from "themes/administration/analytics/components";

function AnalyticsGraphLoader(props) {
    return <AnalyticsGraphLoaderTemplate {...props} />;
}

export default AnalyticsGraphLoader;
